shadow$provide[470] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform mat4 transformMatrix;

vec4 transformPosition(vec4 position, inout vec4 stpq) {
  return transformMatrix * vec4(position.xyz, 1.0);
}
`;

};